import {fetchContainerDetail} from "../network/LineHaulNetworkAPI";

export const LineHaulDetailReducer = (state, action) => {
    switch (action.type) {
        case "LOAD_VIEW":
            const {lineHaulId, filter, dispatcher, isCPTFilterEnabled} = action.data;
            fetchContainerDetail(lineHaulId, filter, dispatcher, isCPTFilterEnabled)
            return state
        case "RECEIVE_DATA":
            const updatedDetails = action.data.details.map(detail => {
                return {
                    ...detail,
                    open: false
                }
            })
            return {...state, details: updatedDetails}
        case "EXPAND_CONTAINER_DATA":
            const expandedDetails = state.details.map(detail =>
                detail.containerId === action.data
                    ? { ...detail, open: !detail.open }
                    : detail);
            return {...state, details: expandedDetails}
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/components/linehaul/reducers/LineHaulDetailReducer.js